import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';
import localePt from '@angular/common/locales/pt';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  withInterceptorsFromDi,
  provideHttpClient,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { PaginacaoService } from './app/services/util/paginacao.service';
import { BreadcrumbService } from './app/main/layout/breadcrumb/app.breadcrumb.service';
import { MenuService } from './app/main/layout/menu/app.menu.service';
import { PubSubService } from './app/services/util/pub-sub.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormService } from './app/services/util/form.service';
import { AlertService } from './app/services/util/alert.service';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from './app/app.routes';
import { registerLocaleData } from '@angular/common';
import { createApollo } from './app/apollo.config';
import { HttpLink } from 'apollo-angular/http';
import { AuthService } from './app/services/auth/auth.service';
import { DialogService } from 'primeng/dynamicdialog';

registerLocaleData(localePt)

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink, authService: AuthService) => createApollo(httpLink, authService),
      deps: [HttpLink, AuthService]
    },
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      ApolloModule
    ),
    DialogService,
    AlertService,
    FormService,
    ConfirmationService,
    MessageService,
    PubSubService,
    MenuService,
    BreadcrumbService,
    PaginacaoService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(APP_ROUTES),
  ],
}).catch((err) => console.error(err));
